if (!customElements.get('language-select')) {
  customElements.define('language-select',
    class LanguageSelect extends HTMLElement {
      constructor() {
        super();
        this.select = this.querySelector('select');
        this.flag = this.querySelector('span.fi');
      }

      connectedCallback() {
        this.select.addEventListener('change', (e) => {
          this.handleChange(e.target.value);
        });

        this.addEventListener('form:clear', () => {
          this.handleClear();
        });
      }

      handleChange(value) {
        this.flag.className = '';

        if (value === '') {
          this.select.classList.remove('select__select--is-selected');
          return;
        }

        this.flag.classList.add('fi');
        this.flag.classList.add(`fi-${value}`);
      }

      handleClear() {
        this.select.value = window.Shopify.locale;
        let newIndex = 0;

        [...this.select.options].forEach((option, index) => {
          if (option.value === this.select.value) {
            newIndex = index;
          }
        });

        this.select.selectedIndex = newIndex;
        this.handleChange(newIndex !== 0 ? this.select.options[newIndex].value : '');
      }
    }
  );
}
